import { Checkbox, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type Props = {
  title: ReactNode | string;
  children?: ReactNode;
  isSelected?: boolean;
  onClick?: () => void;
  'data-testid'?: string;
  width?: number;
};

export const SelectableCard = ({
  width = 350,
  title,
  children,
  isSelected = false,
  onClick,
  'data-testid': dataTestId,
}: Props) => {
  return (
    <Stack
      borderRadius={3}
      width={width}
      minWidth={width}
      maxWidth={width}
      border="1px solid"
      borderColor={isSelected ? 'primary.main' : 'border.main'}
      data-testid={dataTestId}
    >
      <Stack
        direction="row"
        alignItems="center"
        padding={2}
        borderRadius={3}
        sx={(theme) => ({
          background: isSelected ? theme.palette.primary.light : theme.palette.background.default,
          borderBottom: '1px solid',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          borderColor: isSelected ? theme.palette.primary.main : theme.palette.border.main,
        })}
        justifyContent="center"
      >
        <Checkbox onClick={onClick} checked={isSelected} /> <Typography fontWeight="bold">{title}</Typography>
      </Stack>
      {children}
    </Stack>
  );
};
